<template>
  <FloatingButton @openModal="openModal"/>
</template>

<script>
export default {
  name: 'MoleculeFloatingButton',

  components: {
    FloatingButton: () => import('@/components/atoms/AtomFloatingButton')
  },

  methods: {
    openModal () {
      if (!this.$modal.isModalVisible) {
        this.$modal.showModal('MoleculeSupportModal')
      } else if (this.$modal.isModalVisible && this.$modal.modalBody !== 'MoleculeSupportModal') {
        this.$modal.closeModal()
        this.$modal.showModal('MoleculeSupportModal')
      } else if (this.$modal.isModalVisible && this.$modal.modalBody === 'MoleculeSupportModal') {
        this.$modal.closeModal()
      }
    }
  }
}
</script>
